import React from 'react'
import { observer } from 'mobx-react-lite'
import type EditorStore from '../app/stores/EditorStore'
import type { Textbox } from '../app/models/shootTextbox'

export interface ShootsTextboxEditorProps {
  textbox: Textbox;
  editorStore: EditorStore;
  inputRef: React.RefObject<HTMLInputElement>;
  /** Pixel font size matching canvas scaling. */
  fontSizePx: number;
  onBlur: () => void;
}

/**
 * Near-invisible single-line input over a textbox: canvas shows live text; caret uses text color.
 */
export const ShootsTextboxEditor = observer(function ShootsTextboxEditor ({
  textbox,
  editorStore,
  inputRef,
  fontSizePx,
  onBlur
}: ShootsTextboxEditorProps) {
  const lineH = Math.max(28, Math.round(fontSizePx * 1.35))

  return (
    <input
      ref={inputRef}
      type="text"
      value={textbox.text}
      onChange={(e) => editorStore.updateTextbox(textbox.id, { text: e.currentTarget.value })}
      onBlur={onBlur}
      autoComplete="off"
      autoCorrect="off"
      spellCheck={false}
      aria-label="Edit overlay text"
      style={{
        position: 'absolute',
        left: `${textbox.x * 100}%`,
        top: `${textbox.y * 100}%`,
        width: `${textbox.width * 100}%`,
        height: `${textbox.height * 100}%`,
        minHeight: lineH,
        zIndex: 35,
        margin: 0,
        padding: '2px 4px',
        border: 'none',
        outline: 'none',
        boxSizing: 'border-box',
        background: 'transparent',
        color: 'transparent',
        caretColor: textbox.color,
        fontSize: fontSizePx,
        lineHeight: `${lineH}px`,
        fontFamily: textbox.fontFamily,
        touchAction: 'manipulation'
      }}
    />
  )
})
